"use client";

import { useIncrementBlogView } from "@/hooks/blog/useIncrementBlogView";

/**
 * Client island: fires the best-effort view-count POST once per slug mount.
 * Rendered inside the server-rendered <BlogArticle>; renders no markup.
 */
export const BlogViewPing: React.FC<{ slug: string }> = ({ slug }) => {
  useIncrementBlogView(slug);
  return null;
};
